import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminReglasRevisionPage } from "@/features/admin-gestion-documental/components/AdminReglasRevisionPage";

/** Ruta `/admin/reglas-revision-documental` · Gestión Documental (fase 2) · revisión por área/solicitante. */
export const Route = createFileRoute("/_authed-tw/admin/reglas-revision-documental")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminGestionDocumental]}>
      <AdminReglasRevisionPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
